import { Button, Label } from 'semantic-ui-react'
import styled from 'styled-components'

export const StyledFileWrapper = styled.div`
margin-bottom: 5px;
margin-left: 0;
display: flex;
justify-content: space-between;
width: 200px;
`
export const StyledDeleteButton = styled(Button)`
position: absolute;
top: 5px;
right: ${props => props.rightAlign ? `${props.rightAlign}px` : '0'};
`

export const StyledFileLabel = styled(Label)`
display: flex !important;
cursor: pointer;
width: 100%;
 .fileName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
 }
`